import OpenAI from "openai";

export enum ClientAPIKey {
  OPENAI = "OPENAI",
  TOGETHER = "TOGETHER",
  OPENROUTER = "OPENROUTER",
}

export const generateClient = (apiKey: ClientAPIKey) => {
  return new OpenAI({
    apiKey: apiKey,
    baseURL: `${window.location.origin}/v1`,
    dangerouslyAllowBrowser: true,
  });
};

export const callModelEndpoint = async ({
  model,
  messages,
  temperature = 0.7,
  max_tokens = 1000,
  clientKey = ClientAPIKey.OPENAI,
}) => {
  const client = generateClient(clientKey);

  return client.chat.completions.create({
    model,
    messages,
    temperature,
    max_tokens,
  });
};
